import { fromJS, Record } from 'immutable';
import { omitBy } from 'lodash';
import {
  generateKeys,
  generateSchema,
  hasValue,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { AddressData } from '../../geolocation-data/models/address-data.model';
import { IModelValidator } from '../../shared/interfaces/model-validator.interface';

export const SHIPPING_SCHEMA = Object.freeze({
  DATE: null, // i2g-timezoneless-date (yyyy-mm-dd)
  AMOUNT: 0,
  FOB: null, // ''
  VIA: null, // ''
  TRACKING_NUMBER: null, // ''
  ADDRESS: null, // ''
  ADDRESS_DATA: AddressData,
});
const RECORD = generateSchema(SHIPPING_SCHEMA);
const KEYS: any = generateKeys(SHIPPING_SCHEMA);

export class Shipping extends Record(RECORD) implements IModelValidator {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.ADDRESS_DATA,
        value: props.get(KEYS.ADDRESS_DATA)
          ? new AddressData(this.addressData)
          : null,
      },
    ]);

    return selfModel as Shipping;
  }

  get address(): string {
    return this.get(KEYS.ADDRESS);
  }

  get amount(): number {
    return this.get(KEYS.AMOUNT);
  }

  get date(): string {
    return this.get(KEYS.DATE);
  }

  get via(): string {
    return this.get(KEYS.VIA);
  }

  get trackingNumber(): string {
    return this.get(KEYS.TRACKING_NUMBER);
  }

  get fob(): string {
    return this.get(KEYS.FOB);
  }

  get addressData(): AddressData {
    return this.get(KEYS.ADDRESS_DATA);
  }

  hasValue(): boolean {
    return hasValue(
      KEYS,
      omitBy(
        SHIPPING_SCHEMA,
        (_, key) => key.toLowerCase() === KEYS.DATE.toLowerCase()
      ),
      this
    );
  }
}
